// Máscaras de entrada para os formulários de cliente.
// São aplicadas no onChange e o valor é gravado já formatado.

const PREPOSICOES = ['de', 'da', 'do', 'das', 'dos', 'e'];

export function onlyDigits(v: string): string {
  return v.replace(/\D/g, '');
}

// (11) 3333-4444 (fixo, 10 dígitos) ou (11) 99999-9999 (celular, 11 dígitos)
export function maskTelefone(v: string): string {
  const d = onlyDigits(v).slice(0, 11);
  if (d.length === 0) return '';
  if (d.length <= 2) return `(${d}`;
  const ddd = d.slice(0, 2);
  const num = d.slice(2);
  const corte = d.length === 11 ? 5 : 4;
  if (num.length <= corte) return `(${ddd}) ${num}`;
  return `(${ddd}) ${num.slice(0, corte)}-${num.slice(corte)}`;
}

// 00000-000
export function maskCep(v: string): string {
  const d = onlyDigits(v).slice(0, 8);
  if (d.length <= 5) return d;
  return `${d.slice(0, 5)}-${d.slice(5)}`;
}

// CPF 000.000.000-00 (até 11 dígitos) ou CNPJ 00.000.000/0000-00 (12 a 14 dígitos)
export function maskCpfCnpj(v: string): string {
  const d = onlyDigits(v).slice(0, 14);
  if (d.length <= 11) {
    return d
      .replace(/^(\d{3})(\d)/, '$1.$2')
      .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d{1,2})$/, '.$1-$2');
  }
  return d
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2');
}

// Cidade, endereço, bairro e complemento: inicial maiúscula em cada palavra, preposições em minúsculo (exceto a primeira palavra).
// Preserva espaços para não atrapalhar a digitação; use trimEspacos no onBlur.
export function formatNomeProprio(v: string): string {
  let primeira = true;
  return v
    .split(' ')
    .map(palavra => {
      if (!palavra) return palavra;
      const minuscula = palavra.toLocaleLowerCase('pt-BR');
      const ehPrimeira = primeira;
      primeira = false;
      if (!ehPrimeira && PREPOSICOES.includes(minuscula)) return minuscula;
      return palavra.charAt(0).toLocaleUpperCase('pt-BR') + palavra.slice(1);
    })
    .join(' ');
}

export function trimEspacos(v: string): string {
  return v.trim().replace(/\s+/g, ' ');
}
